import BrandSubscriptionServiceCallState from 'owa-brands-subscriptions-option/lib/store/schema/BrandSubscriptionServiceCallState';
import { hideFullOptions } from 'owa-options-core';
import { orchestrator } from 'satcheljs';
import { setServiceCallState } from 'owa-brands-subscriptions-option/lib/actions/internalActions';

export default orchestrator(hideFullOptions, actionMessage => {
    setServiceCallState(BrandSubscriptionServiceCallState.NotCalled);
});
